(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
	var lity = require('lity')();
	var scrollTop = 0;

	$(document.body).on('click', '[href$=".jpg"],[href$=".jpeg"],[href$=".png"],[href$=".gif"],[data-lightbox]', function (e) {
		e.preventDefault();

		scrollTop = $(document).scrollTop();
		lity($(this).attr('href'));
	});

	$(document.body).on('lity:close', function () {
		$(document).scrollTop(scrollTop);
	});

	// If a hash is set, and a popup exists, open it
	if (window.location.hash) {
		var id = window.location.hash.substr(1);

		if (document.getElementById(id)) {
			if ($('a[href="#' + id + '"][data-lightbox]').length) {
				lity('#' + id);
			}
		}
	}
})();
